import locale from "date-fns/esm/locale/pl"
import getDaysInMonth from "date-fns/getDaysInMonth"

export const weekdays = [...Array(7).keys()].map(i => locale.localize.day(i, { width: "short" }))
export const days = date => Array.from(Array(getDaysInMonth(date)))